import http from '../../../../config/BaseUrl'
import { upcomingEventItemList, upcomingEventLoading } from './upcomingEventSlice'

export const upcomingEventList = (params) => async (dispatch) => {
    try{
        dispatch(upcomingEventLoading())
        await http.get('upcoming-event', {params})
        .then((res) => {
           dispatch(upcomingEventItemList(res.data.event))
        }).catch((err) => {
            console.log(err.response.data.message);
        })
    }catch(error){

    }
}